import { z } from 'zod';
import { apiGet, apiSend } from '@/lib/api';

export const MachineReachSchema = z.object({
  id: z.string(),
  vmid: z.number(),
  name: z.string(),
  directEmployees: z.number(),
  groups: z.number(),
  /** RÓŻNI pracownicy z dostępem: bezpośrednio LUB przez grupę */
  effectiveReach: z.number(),
  alsoOnOtherMachines: z.number(),
  pending: z.boolean(),
});

export type MachineReach = z.infer<typeof MachineReachSchema>;

export const fetchMachineReach = (groupId: string) =>
  apiGet(`/assignments/machines?groupId=${groupId}`, z.array(MachineReachSchema));

const MachineRefSchema = z.object({ id: z.string(), vmid: z.number(), name: z.string() });

/**
 * ⚠️ `spsUserNumber` to NUMER KARTY (`Users.USERNUMBER`), tekstowy klucz główny w SPS.
 * `alias` (`Users.ALIAS`) to numer DODATKOWY. Wcześniej pola nazywały się `spsUserId`
 * i `descr` — pierwsze sugerowało liczbę, drugie w ogóle nie istnieje w SPS jako osobne pole.
 */
const EmployeeLinksSchema = z.object({
  machine: MachineRefSchema,
  assigned: z.array(
    z.object({
      id: z.string(),
      spsUserNumber: z.string(),
      name: z.string(),
      alias: z.string().nullable(),
      machineCount: z.number(),
    }),
  ),
  candidates: z.array(
    z.object({
      id: z.string(),
      spsUserNumber: z.string(),
      name: z.string(),
      alias: z.string().nullable(),
    }),
  ),
});

export type EmployeeLinks = z.infer<typeof EmployeeLinksSchema>;

const GroupRefSchema = z.object({
  id: z.string(),
  /** Kod grupy — TEKST, u klientów zwykle słowo. */
  spsGroupNumber: z.string(),
  name: z.string(),
  members: z.number(),
  rationing: z.number(),
});

const GroupLinksSchema = z.object({
  machine: MachineRefSchema,
  assigned: z.array(GroupRefSchema),
  candidates: z.array(GroupRefSchema),
});

export type GroupLinks = z.infer<typeof GroupLinksSchema>;

export const fetchEmployeeLinks = (machineId: string, groupId: string, search: string) => {
  const q = new URLSearchParams({ groupId, limit: '50' });
  if (search) q.set('search', search);
  return apiGet(`/assignments/machine/${machineId}/employees?${q.toString()}`, EmployeeLinksSchema);
};

export const fetchGroupLinks = (machineId: string, groupId: string) =>
  apiGet(`/assignments/machine/${machineId}/groups?groupId=${groupId}`, GroupLinksSchema);

const OpSchema = z.object({ opId: z.string() });

export const updateEmployeeLinks = (
  machineId: string,
  payload: { groupId: string; add: string[]; remove: string[] },
) => apiSend('POST', `/assignments/machine/${machineId}/employees`, payload, OpSchema);

export const updateGroupLinks = (machineId: string, payload: { groupId: string; add: string[]; remove: string[] }) =>
  apiSend('POST', `/assignments/machine/${machineId}/groups`, payload, OpSchema);
